import React from 'react';

interface IProps {
  size?: number;
  className?: string;
}
export const Spacer = ({ size = 1, className }: IProps) => (
  <div className={className || ''} style={{ height: 10 * size, minWidth: 10 }} />
);
